import React, {useEffect} from 'react';
import {inject, observer} from 'mobx-react';
import TimeToStartTimer from 'app/utils/TimeToStartTimer';
import {CurrentTimeStore} from 'stores/current_time_store';
import {SEC_IN_DAY} from 'app/utils/Consts';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import I18n from 'app/i18n';

interface PromoNewCardTimerProps {
    endTime: number
    onExpire: () => void
    currentTimeStore?: CurrentTimeStore
}

const PromoNewCardTimer = ({endTime, onExpire, currentTimeStore}: PromoNewCardTimerProps): React.ReactElement | null => {
    const currentTime = currentTimeStore?.t ?? 0;
    const isExpired = Boolean(endTime && currentTimeStore && endTime - currentTime < 0);
    const showDays = endTime - currentTime >= SEC_IN_DAY;
    const daysRemaining = Math.floor((endTime - currentTime) / SEC_IN_DAY);

    useEffect(() => {
        if (isExpired) {
            onExpire();
        }
    }, [isExpired, onExpire]);

    if (!endTime || !currentTimeStore || isExpired) {
        return null;
    }

    return (
        <div className="promo-new-card__timer">
            <SpriteIcon name="#svg-timer-icon" size={{height: 16, width: 16}} />
            <span className="promo-new-card__timer-text">
                {showDays
                    ? `${daysRemaining} ${I18n.t('days_short')}`
                    : <TimeToStartTimer time_to_start={endTime} showOnlyDays={false} />}
            </span>
        </div>
    );
};

export default inject('currentTimeStore')(observer(PromoNewCardTimer));
